import RatingStars from '../common/RatingStars';
import { useTranslation } from 'react-i18next';
import { LoadingSpinner } from '../LoadingSpinner';
import { FreelancerStats } from '../../types/profile';
import { ReviewData } from '../../stores/reviewStore';
import CollapsibleContent from '../common/CollapsibleContent';
import { ReviewList } from '../reviews/ReviewList';

const ProfileReviewsSection = ({
  loading,
  reviews,
  hasMoreReviews,
  fetchMoreReviews,
  freelancerStats,
  className,
}: {
  loading: boolean;
  reviews: ReviewData[];
  hasMoreReviews: boolean;
  fetchMoreReviews: () => void;
  freelancerStats: FreelancerStats;
  className?: string;
}) => {
  const { t } = useTranslation(['common', 'reviews']);

  return (
    <div
      className={`bg-white  rounded-2xl  border-2 shadow-xl border-gray-300 mb-6  py-4 px-6 ${className}`}
    >
      {loading ? (
        <div className="flex justify-center py-8">
          <LoadingSpinner />
        </div>
      ) : (
        <>
          <CollapsibleContent
            header={
              <div className="mb-2 text-lg font-bold text-secondary">
                {t('review', { ns: 'reviews', defaultValue: 'Évaluation' })}
              </div>
            }
          >
            {freelancerStats.overall_rating && (
              <div className="mb-2 flex gap-4 border-b border-[#E0E0E0] pb-4">
                <span className="text-sm font-bold">
                  {t(`ratingLabels.${freelancerStats.overall_rating}`, { ns: 'common' })}
                </span>
                <div className="flex items-center gap-4">
                  <RatingStars rating={freelancerStats.overall_rating} />
                  <span className="text-sm text-secondary">
                    (
                    {freelancerStats.reviews_count > 1
                      ? t('review_counts_plural', {
                          ns: 'reviews',
                          count: freelancerStats.reviews_count,
                        })
                      : t('review_counts_one', {
                          ns: 'reviews',
                          count: freelancerStats.reviews_count,
                        })}
                    )
                  </span>
                </div>
              </div>
            )}

            <ReviewList
              hasMoreReviews={hasMoreReviews}
              reviews={reviews}
              fetchMoreReviews={fetchMoreReviews}
            />
          </CollapsibleContent>
        </>
      )}
    </div>
  );
};

export default ProfileReviewsSection;
